import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import {
  bool, func, node, string,
} from 'prop-types';
import Loader from '../atoms/Loader';

export default class Modal extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    children: node.isRequired,
    footer: node,
    onClose: func.isRequired,
    isActive: bool,
    loading: bool,
  };

  el = document.createElement('div');

  componentDidMount() {
    const root = document.getElementById('root');
    root.appendChild(this.el);
  }

  componentWillUnmount() {
    const root = document.getElementById('root');
    root.appendChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.renderModal(), this.el);
  }

  renderModal() {
    const {
      title, children, isActive, footer, onClose, className,
    } = this.props;

    return (
      <>
        <div className="modal" style={{ display: isActive ? 'flex' : 'none' }}>
          <div className="modal-background" />
          <div
            className={`modal-card ${className}`}
            style={{ overflow: 'visible' }}
          >
            <header className="modal-card-head">
              <p className="modal-card-title">{title}</p>
              <button className="delete" aria-label="close" onClick={onClose} />
            </header>
            <section className="modal-card-body">
              {isActive && children}
              {footer}
            </section>
          </div>
        </div>
        {this.props.loading && <Loader />}
      </>
    );
  }
}

Modal.displayName = 'Modal';
